import { action, makeObservable, observable } from 'mobx';
import { Log } from '@/helper/log';
import { FlightDetailsParser } from './parse';

type TransferOption = '' | 'protected_by_airline' | 'self_transfer';
const METHOD_NAMES = {
  UPDATE_DATA: 'updateData',
} as const;

export default class FlightDetailsStore {
  private CLASS_NAME = 'FlightDetailsStore';
  @observable showTransferInfo = false;
  @observable showJourneyDetails = false;
  @observable transferOption: TransferOption = '';
  @observable journeyLegDetails: AACheckout.JourneyLegDetail[] = [];
  @observable journeyLegs: AACheckout.JourneyLeg[] = [];
  @observable stationDetails: AACheckout.StationDetails = {};

  originalflightDetails = null;

  constructor() {
    makeObservable(this);
  }

  @action
  updateData = async (originalPageData) => {
    this.originalflightDetails = originalPageData.flightDetails;

    try {
      await new FlightDetailsParser(
        originalPageData,
        this.protectedByActionCallback,
        this.selfTransferActionCallback,
        this.flightDetailsParserCallBack,
      ).parse();
    } catch (e) {
      Log.errorData(e, this.CLASS_NAME, METHOD_NAMES.UPDATE_DATA);
    }
  };

  @action
  flightDetailsParserCallBack = async (
    journeyLegDetails: AACheckout.JourneyLegDetail[],
    journeyLegs: AACheckout.JourneyLeg[],
    stationDetails: AACheckout.StationDetails,
  ) => {
    if (
      JSON.stringify(journeyLegDetails) !==
      JSON.stringify(this.journeyLegDetails)
    ) {
      this.journeyLegDetails = journeyLegDetails;
    }

    if (JSON.stringify(journeyLegs) !== JSON.stringify(this.journeyLegs)) {
      this.journeyLegs = journeyLegs;
    }

    if (
      JSON.stringify(stationDetails) !== JSON.stringify(this.stationDetails)
    ) {
      this.stationDetails = stationDetails;
    }
  };

  @action
  toggleOnShowJourneyDetails = async () => {
    this.showJourneyDetails = true;
  };

  @action
  toggleOffShowJourneyDetails = async () => {
    this.showJourneyDetails = false;
  };

  @action
  protectedByActionCallback = async () => {
    this.showTransferInfo = true;
    this.transferOption = 'protected_by_airline';
  };

  @action
  selfTransferActionCallback = async () => {
    this.showTransferInfo = true;
    this.transferOption = 'self_transfer';
  };

  @action
  onKnowIt = async () => {
    this.showTransferInfo = false;
  };

  composeCheckoutData() {
    const bookingFlightDetails = {
      cartDetails: this.originalflightDetails.cartDetails,
      flightDetails:
        this.originalflightDetails.flightDetails ||
        this.originalflightDetails.flightDetails.flightDetails,
      priceChanged:
        this.originalflightDetails.priceChanged ||
        this.originalflightDetails.flightDetails.priceChanged,
    };

    return {
      bookingFlightDetails,
      tripType: this.journeyLegDetails.length > 1 ? 'R' : 'O',
    };
  }
}
